import { restApi } from '@icp/settings';

export const CommitContentType = {
  FORM: 'form',
  FLOW: 'flow',
  FRONTEND: 'frontend',
  PAGE: 'page',
  PBC: 'pbc',
};

export async function getCommitTriggerSetting(projectToken) {
  try {
    const result = await restApi.get(
      `/form/api/project-settings/project-settings-properties/get-by-project-token/${projectToken}`,
    );
    const commitTriggerUrl = result?.client?.commitTriggerUrl;
    return commitTriggerUrl;
  } catch (e) {
    return null;
  }
}

export async function commit(projectId, type, message, data) {
  const payload = { type, message, data };
  return restApi.post(`/form/api/project/commit/${projectId}`, payload);
}
